export const GoogleButton = ({ width = '167', height = '48' }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      viewBox="0 0 167 48"
      fill="none"
    >
      <path
        d="M160 48H6.15385C2.77077 48 0 45.2985 0 42V6C0 2.7015 2.77077 -1.90735e-06 6.15385 -1.90735e-06H160C163.383 -1.90735e-06 166.154 2.7015 166.154 6V42C166.154 45.2985 163.383 48 160 48Z"
        fill="black"
      />
      <path
        d="M12.8432 9.04701C12.4817 9.41601 12.2725 9.99051 12.2725 10.7345V37.2725C12.2725 38.0165 12.4817 38.591 12.8432 38.96L12.9325 39.041L28.1848 24.176V23.825L12.9325 8.96001L12.8432 9.04701Z"
        fill="url(#paint0_linear_5695_40073)"
      />
      <path
        d="M33.2633 29.1328L28.1848 24.1753V23.8243L33.2694 18.8668L33.3833 18.9313L39.4048 22.2718C41.1233 23.2198 41.1233 24.7798 39.4048 25.7338L33.3833 29.0683L33.2633 29.1328Z"
        fill="url(#paint1_linear_5695_40073)"
      />
      <path
        d="M33.3832 29.069L28.1847 24.0005L12.8432 38.96C13.414 39.545 14.3447 39.6155 15.4032 39.0305L33.3832 29.069Z"
        fill="url(#paint2_linear_5695_40073)"
      />
      <path
        d="M33.3833 18.9315L15.4033 8.97C14.3448 8.391 13.414 8.4615 12.8433 9.0465L28.1848 24L33.3833 18.9315Z"
        fill="url(#paint3_linear_5695_40073)"
      />
      <path
        d="M58.3601 12.2928C58.3601 13.2948 58.0524 14.0973 57.4463 14.6958C56.7494 15.4053 55.8417 15.7623 54.7294 15.7623C53.6663 15.7623 52.7586 15.3993 52.014 14.6838C51.2678 13.9578 50.8955 13.0668 50.8955 12.0003C50.8955 10.9338 51.2678 10.0428 52.014 9.32278C52.7586 8.60128 53.6663 8.23828 54.7294 8.23828C55.2586 8.23828 55.7632 8.34478 56.2447 8.54278C56.7247 8.74228 57.1155 9.01228 57.3986 9.34528L56.7555 9.97828C56.2617 9.40978 55.5894 9.12928 54.7294 9.12928C53.954 9.12928 53.2817 9.39328 52.7109 9.92578C52.1463 10.4598 51.8632 11.1513 51.8632 12.0003C51.8632 12.8493 52.1463 13.5468 52.7109 14.0808C53.2817 14.6073 53.954 14.8773 54.7294 14.8773C55.5524 14.8773 56.2447 14.6073 56.7909 14.0748C57.1509 13.7223 57.3555 13.2363 57.4094 12.6153H54.7294V11.7483H58.3047C58.3478 11.9358 58.3601 12.1173 58.3601 12.2928Z"
        fill="white"
        stroke="white"
        strokeWidth="0.16"
        strokeMiterlimit="10"
      />
      <path
        d="M64.0325 9.28584H60.674V11.5658H63.7017V12.4328H60.674V14.7128H64.0325V15.5963H59.7233V8.40234H64.0325V9.28584Z"
        fill="white"
        stroke="white"
        strokeWidth="0.16"
        strokeMiterlimit="10"
      />
      <path
        d="M68.0355 15.5963H67.0848V9.28584H65.0248V8.40234H70.0971V9.28584H68.0355V15.5963Z"
        fill="white"
        stroke="white"
        strokeWidth="0.16"
        strokeMiterlimit="10"
      />
      <path
        d="M73.7677 15.5963V8.40234H74.7169V15.5963H73.7677Z"
        fill="white"
        stroke="white"
        strokeWidth="0.16"
        strokeMiterlimit="10"
      />
      <path
        d="M78.9247 15.5963H77.9816V9.28584H75.9139V8.40234H80.9924V9.28584H78.9247V15.5963Z"
        fill="white"
        stroke="white"
        strokeWidth="0.16"
        strokeMiterlimit="10"
      />
      <path
        d="M90.5955 14.6718C89.8678 15.3993 88.9663 15.7623 87.8909 15.7623C86.8093 15.7623 85.9078 15.3993 85.1801 14.6718C84.4539 13.9458 84.0924 13.0548 84.0924 12.0003C84.0924 10.9458 84.4539 10.0548 85.1801 9.32878C85.9078 8.60128 86.8093 8.23828 87.8909 8.23828C88.9601 8.23828 89.8616 8.60128 90.5893 9.33478C91.3216 10.0668 91.6832 10.9518 91.6832 12.0003C91.6832 13.0548 91.3216 13.9458 90.5955 14.6718ZM85.8832 14.0688C86.4309 14.6073 87.097 14.8773 87.8909 14.8773C88.6786 14.8773 89.3509 14.6073 89.8924 14.0688C90.4386 13.5303 90.7155 12.8388 90.7155 12.0003C90.7155 11.1618 90.4386 10.4703 89.8924 9.93178C89.3509 9.39328 88.6786 9.12328 87.8909 9.12328C87.097 9.12328 86.4309 9.39328 85.8832 9.93178C85.337 10.4703 85.0601 11.1618 85.0601 12.0003C85.0601 12.8388 85.337 13.5303 85.8832 14.0688Z"
        fill="white"
        stroke="white"
        strokeWidth="0.16"
        strokeMiterlimit="10"
      />
      <path
        d="M93.017 15.5963V8.40234H94.1708L97.7585 13.9973H97.8L97.7585 12.6143V8.40234H98.7077V15.5963H97.717L93.96 9.72534H93.9185L93.96 11.1143V15.5963H93.017Z"
        fill="white"
        stroke="white"
        strokeWidth="0.16"
        strokeMiterlimit="10"
      />
      <path
        d="M83.8584 26.1026C80.9677 26.1026 78.6061 28.2476 78.6061 31.2071C78.6061 34.1426 80.9677 36.3101 83.8584 36.3101C86.7553 36.3101 89.1169 34.1426 89.1169 31.2071C89.1169 28.2476 86.7553 26.1026 83.8584 26.1026ZM83.8584 34.3001C82.2723 34.3001 80.9077 33.0236 80.9077 31.2071C80.9077 29.3666 82.2723 28.1126 83.8584 28.1126C85.4446 28.1126 86.8153 29.3666 86.8153 31.2071C86.8153 33.0236 85.4446 34.3001 83.8584 34.3001ZM72.3984 26.1026C69.5015 26.1026 67.1461 28.2476 67.1461 31.2071C67.1461 34.1426 69.5015 36.3101 72.3984 36.3101C75.2938 36.3101 77.6507 34.1426 77.6507 31.2071C77.6507 28.2476 75.2938 26.1026 72.3984 26.1026ZM72.3984 34.3001C70.8107 34.3001 69.4415 33.0236 69.4415 31.2071C69.4415 29.3666 70.8107 28.1126 72.3984 28.1126C73.9846 28.1126 75.3492 29.3666 75.3492 31.2071C75.3492 33.0236 73.9846 34.3001 72.3984 34.3001ZM58.7615 27.6671V29.8361H64.0738C63.9184 31.0481 63.503 31.9391 62.8661 32.5601C62.0907 33.3101 60.883 34.1426 58.7615 34.1426C55.4923 34.1426 52.9323 31.5701 52.9323 28.3826C52.9323 25.1951 55.4923 22.6226 58.7615 22.6226C60.5292 22.6226 61.8154 23.2961 62.7646 24.1691L64.3323 22.6406C63.0046 21.4046 61.2384 20.4551 58.7615 20.4551C54.2784 20.4551 50.5107 24.0116 50.5107 28.3826C50.5107 32.7536 54.2784 36.3101 58.7615 36.3101C61.1846 36.3101 63.0046 35.5361 64.4354 34.0841C65.9015 32.6546 66.3584 30.6446 66.3584 29.0216C66.3584 28.5176 66.3154 28.0541 66.2384 27.6671H58.7615ZM114.525 29.3486C114.092 28.2071 112.758 26.1026 110.041 26.1026C107.349 26.1026 105.108 28.1711 105.108 31.2071C105.108 34.0661 107.326 36.3101 110.3 36.3101C112.705 36.3101 114.092 34.8806 114.663 34.0481L112.878 32.8886C112.283 33.7376 111.472 34.3001 110.3 34.3001C109.135 34.3001 108.3 33.7796 107.765 32.7536L114.766 29.9291L114.525 29.3486ZM107.386 31.0481C107.326 29.0801 108.954 28.0721 110.12 28.0721C111.034 28.0721 111.809 28.5176 112.068 29.1551L107.386 31.0481ZM101.695 35.9996H103.997V20.9996H101.695V35.9996ZM97.9261 27.2396H97.8492C97.3323 26.6426 96.3461 26.1026 95.0969 26.1026C92.4753 26.1026 90.0784 28.3466 90.0784 31.2236C90.0784 34.0841 92.4753 36.3101 95.0969 36.3101C96.3461 36.3101 97.3323 35.7656 97.8492 35.1506H97.9261V35.8826C97.9261 37.8341 96.8569 38.8826 95.1323 38.8826C93.7261 38.8826 92.8538 37.8926 92.4938 37.0601L90.4923 37.8746C91.0692 39.2276 92.5969 40.8926 95.1323 40.8926C97.8307 40.8926 100.108 39.3446 100.108 35.5781V26.4131H97.9261V27.2396ZM95.2938 34.3001C93.7077 34.3001 92.38 33.0056 92.38 31.2236C92.38 29.4251 93.7077 28.1126 95.2938 28.1126C96.8569 28.1126 98.0892 29.4251 98.0892 31.2236C98.0892 33.0056 96.8569 34.3001 95.2938 34.3001ZM125.3 20.9996H119.795V35.9996H122.091V30.3161H125.3C127.849 30.3161 130.349 28.5176 130.349 25.6571C130.349 22.7981 127.843 20.9996 125.3 20.9996ZM125.36 28.2296H122.091V23.0861H125.36C127.074 23.0861 128.052 24.4736 128.052 25.6571C128.052 26.8181 127.074 28.2296 125.36 28.2296ZM139.549 26.0741C137.891 26.0741 136.166 26.7881 135.457 28.3706L137.494 29.2031C137.932 28.3706 138.738 28.1006 139.591 28.1006C140.781 28.1006 141.989 28.7981 142.008 30.0296V30.1871C141.592 29.9531 140.703 29.6066 139.609 29.6066C137.415 29.6066 135.18 30.7841 135.18 32.9816C135.18 34.9916 136.977 36.2861 138.997 36.2861C140.541 36.2861 141.394 35.6066 141.929 34.8161H142.008V35.9756H144.225V30.2216C144.225 27.5621 142.188 26.0741 139.549 26.0741ZM139.272 34.2941C138.521 34.2941 137.475 33.9311 137.475 33.0236C137.475 31.8626 138.78 31.4171 139.909 31.4171C140.92 31.4171 141.394 31.6346 142.008 31.9211C141.828 33.3101 140.601 34.2941 139.272 34.2941ZM152.301 26.4026L149.663 32.9051H149.585L146.857 26.4026H144.381L148.48 35.4896L146.141 40.5461H148.54L154.855 26.4026H152.301ZM131.611 35.9996H133.912V20.9996H131.611V35.9996Z"
        fill="white"
      />
      <defs>
        <linearGradient
          id="paint0_linear_5695_40073"
          x1="26.8305"
          y1="37.5489"
          x2="6.69811"
          y2="16.9002"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#00A0FF" />
          <stop offset="0.0066" stopColor="#00A1FF" />
          <stop offset="0.2601" stopColor="#00BEFF" />
          <stop offset="0.5122" stopColor="#00D2FF" />
          <stop offset="0.7604" stopColor="#00DFFF" />
          <stop offset="1" stopColor="#00E3FF" />
        </linearGradient>
        <linearGradient
          id="paint1_linear_5695_40073"
          x1="41.6425"
          y1="23.9981"
          x2="11.8617"
          y2="23.9981"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FFE000" />
          <stop offset="0.4087" stopColor="#FFBD00" />
          <stop offset="0.7754" stopColor="#FFA500" />
          <stop offset="1" stopColor="#FF9C00" />
        </linearGradient>
        <linearGradient
          id="paint2_linear_5695_40073"
          x1="30.5564"
          y1="21.2451"
          x2="3.25522"
          y2="-6.7561"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FF3A44" />
          <stop offset="1" stopColor="#C31162" />
        </linearGradient>
        <linearGradient
          id="paint3_linear_5695_40073"
          x1="8.98148"
          y1="47.7886"
          x2="21.1727"
          y2="35.2849"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#32A071" />
          <stop offset="0.0685" stopColor="#2DA771" />
          <stop offset="0.4762" stopColor="#15CF74" />
          <stop offset="0.8009" stopColor="#06E775" />
          <stop offset="1" stopColor="#00F076" />
        </linearGradient>
      </defs>
    </svg>
  );
};
